import React from "react";
import { Chart } from "chart.js/auto"
import { CategoryScale } from "chart.js";
import { Line } from "react-chartjs-2";
import { displayMessage } from "../../services/helper";

Chart.register(CategoryScale);

export default function EvoMonitoryChart({ evoMonitoryChart }) {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                max: 3.5,
                min: 0,
                ticks: {
                    stepSize: 0.5

                },
            },
        },
        type: 'line',
        plugins: {
            tooltip: {
                callbacks: {
                    footer: (context) => {
                        const tooltip = evoMonitoryChart.penalty_data_obj.find(value => value.formattedDate === context[0].label)
                        return [
                            displayMessage('SUM_OPEN_LIP', [tooltip?.sum_open_lip]),
                            displayMessage('SUM_CAMERA_MICROPHONE', [tooltip?.sum_camera_microphone]),
                            displayMessage('SUM_CHEWING', [tooltip?.sum_chewing]),
                            displayMessage('TOTAL_PRESENCES', [tooltip?.total_presences]),
                        ]
                    },
                },
            },
        }
    };

    const data = {
        labels: evoMonitoryChart?.date[0],
        datasets: [
            {
                label: displayMessage('STARS_AVARGE'),
                data: evoMonitoryChart?.avg_monitory_stars[0],
            }
        ],
    };

    return (
        <>
            {data && (
                <Line
                    data={data}
                    width={300}
                    height={300}
                    options={options}
                    style={{ maxHeight: 300 }}
                />
            )}
        </>
    )
}